import { render, staticRenderFns } from "./ChatBoxImageCarousel.vue?vue&type=template&id=2bf3456a&scoped=true"
import script from "./ChatBoxImageCarousel.vue?vue&type=script&lang=js"
export * from "./ChatBoxImageCarousel.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxImageCarousel.vue?vue&type=style&index=0&id=2bf3456a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3456a",
  null
  
)

export default component.exports